import { roles } from "@/constants";
import React from "react";
import { useSelector } from "react-redux";

const CustomTabs = ({ children, currentTab, onTabChange }) => {
  const { role } = useSelector(state => state.auth?.user);

  const tabs = [
    { key: "1", label: "Active Offers" },
    { key: "2", label: "Past Offers" },
    ...(!roles.onlyCompanyAdminAndSales.includes(role)
      ? [{ key: "3", label: "Draft Offers" }]
      : []),
  ];

  return (
    <div>
      {/* Tabs */}
      <div className="inline-flex rounded-t-lg bg-revampBlue">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={
              "outline-none cursor-pointer rounded-t-lg py-3 px-6 text-center text-sm font-semibold flex items-center justify-center transition " +
              (tab.key === currentTab
                ? "bg-white text-gray-600 shadow-lg border-none rounded-t-lg"
                : "bg-revampBlue text-white")
            }
          >
            <span>{tab.label}</span>
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="mt-5">
        {React.Children.map(children, child =>
          child.props.tabKey === currentTab ? child : null
        )}
      </div>
    </div>
  );
};

export default CustomTabs;